import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import i18n from '../../../i18n';

import { Flex, Image, Modal, Text, Title } from '@homeexchange/design';
import Utils from '../../../utils/utils';
import { withRedirectTo } from '../../../utils/verificationRedirect';
import Analytics from '../../../utils/analytics';
import { NAVIGATION_ACTION, NAVIGATION_AREAS, NAVIGATION_TEXT } from '../../analytics/analytics-constants';
import useGTM from '../../analytics/useGTM';

export default function Verification({ showModal, onClose, user }) {
    const { fetchNavigation } = useGTM(user);

    useEffect(() => {
        if (showModal) {
            Analytics.trackGTM(
                'modal',
                fetchNavigation(
                    NAVIGATION_ACTION.VIEW,
                    NAVIGATION_AREAS.VERIFY_YOUR_ACCOUNT_MODAL,
                    NAVIGATION_TEXT.VERIFY_YOUR_ACCOUNT
                )
            );
        }
    }, [showModal]);

    return (
        <Modal
            isOpen={showModal}
            isClosable={true}
            confirmActionText={i18n.t('user:homeView_modale_verifyBlocker_cta')}
            onClose={onClose}
            onConfirmAction={() => {
                Analytics.trackGTM(
                    'button',
                    fetchNavigation(
                        NAVIGATION_ACTION.CLICK,
                        NAVIGATION_AREAS.VERIFY_YOUR_ACCOUNT_MODAL,
                        NAVIGATION_TEXT.VERIFY_YOUR_ACCOUNT
                    ),
                    () => {
                        location.href = withRedirectTo(i18n.t('user:user.verif.url'));
                    }
                );
            }}
        >
            <Flex justifyContent="center">
                <Image
                    width="small"
                    src={`${Utils.getAssetsDomain()}/images/website/verification-check.svg`}
                ></Image>
            </Flex>
            <Title>{i18n.t('user:homeView_modale_verifyBlocker_title')}</Title>
            <Text>{i18n.t('user:homeView_modale_verifyBlocker_body')}</Text>
        </Modal>
    );
}

Verification.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    user: PropTypes.object.isRequired
};
